var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardiology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8999 34.7C68.8999 53.5881 53.5881 68.8999 34.7 68.8999C15.8118 68.8999 0.5 53.5881 0.5 34.7C0.5 15.8118 15.8118 0.5 34.7 0.5C53.5881 0.5 68.8999 15.8118 68.8999 34.7Z",
    fill: "#053A7A",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 31.0523C21.0625 25.9227 24.4774 21.1667 29.1528 21.1667C32.3975 21.1667 34.8055 23.3006 36.2917 26.3276C37.7779 23.3006 40.1859 21.1667 43.4306 21.1667C48.1068 21.1667 51.5208 25.9236 51.5208 31.0523C51.5208 42.0289 36.2917 49.8334 36.2917 49.8334C36.2917 49.8334 26.0335 44.8947 22.3552 36.7937H31.4407L32.8848 34.2271L34.5717 40.1306L38.5223 35.0522H43.4583V33.2605H37.6444L35.3242 36.2436L33.4277 29.6064L30.3926 35.002H21.6717C21.8616 35.6156 22.0918 36.2132 22.3552 36.7937H18.375V35.002H21.6717C21.2704 33.7234 21.065 32.3914 21.0625 31.0514V31.0523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.b8bb32c6ec6ece20bcdb6f9d38a8a65f.svg";
export { ForwardRef as ReactComponent };